import { LegalLayout } from "@/components/LegalLayout";

export default function PrivacyPolicy() {
  const sections = [
    {
      heading: "Overview",
      body: "This Privacy Policy explains how ILFAL (\"we\", \"us\") collects, uses, and protects your personal information when you use our platform. By using ILFAL, you consent to the practices described here.",
    },
    {
      heading: "Information We Collect",
      body: "We collect the following categories of information:",
      list: [
        "Account information you provide, such as your name, email address, and password (stored in hashed form).",
        "Subscription and billing details, which are processed and stored by our third-party payment provider — we do not store full card numbers.",
        "Usage data, such as labs launched, progress, and completion status.",
        "Technical data, such as IP address, browser type, and device information, collected automatically for security and analytics.",
      ],
    },
    {
      heading: "How We Use Your Information",
      body: "We use your information to:",
      list: [
        "Provide, operate, and maintain the Platform and your account.",
        "Process subscriptions and manage access to paid content.",
        "Communicate with you about your account, updates, and support requests.",
        "Improve the Platform, monitor performance, and detect or prevent fraud and abuse.",
        "Comply with legal obligations.",
      ],
    },
    {
      heading: "Cookies and Tracking",
      body: "We use cookies and similar technologies to keep you signed in, remember your preferences, and understand how the Platform is used. You can control cookies through your browser settings, though disabling them may affect functionality such as staying logged in.",
    },
    {
      heading: "Sharing of Information",
      body: "We do not sell your personal information. We share data only with trusted service providers who help us operate the Platform (such as payment processors, email delivery, and hosting), and only to the extent necessary. We may also disclose information where required by law or to protect our rights and users.",
    },
    {
      heading: "Data Retention",
      body: "We retain your personal information for as long as your account is active or as needed to provide the service, comply with legal obligations, resolve disputes, and enforce our agreements. You may request deletion of your account at any time.",
    },
    {
      heading: "Data Security",
      body: "We implement reasonable technical and organizational measures to protect your information, including encryption in transit and hashed password storage. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.",
    },
    {
      heading: "Your Rights",
      body: "Depending on your jurisdiction, you may have the right to access, correct, export, or delete your personal data, and to object to or restrict certain processing. To exercise these rights, contact us at support@ilfal.com.",
    },
    {
      heading: "International Users",
      body: "Your information may be processed and stored in countries other than your own. By using the Platform, you consent to the transfer of your information to jurisdictions that may have different data-protection laws than your country of residence.",
    },
    {
      heading: "Children's Privacy",
      body: "The Platform is not intended for individuals under 18. We do not knowingly collect personal information from children. If you believe a minor has provided us information, please contact us so we can remove it.",
    },
    {
      heading: "Changes to This Policy",
      body: "We may update this Privacy Policy periodically. Material changes will be posted here with a revised \"Last updated\" date. Your continued use of the Platform after changes take effect indicates acceptance of the updated policy.",
    },
    {
      heading: "Contact",
      body: "If you have questions about this Privacy Policy or your data, contact us at support@ilfal.com.",
    },
  ];

  return (
    <LegalLayout
      testid="privacy-policy-page"
      title="Privacy Policy"
      updated="June 2026"
      intro="Your privacy matters to us. This policy describes what data we collect, how we use it, and the choices you have."
      sections={sections}
    />
  );
}
